import { apiClient } from "@/lib/apiClient";

export interface Company {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  createdAt: string;
  updatedAt: string;
  systemPrompt?: string;
  promptFoundation?: string;
  assignedTools?: string[];
  numberId?: string;
  voice?: string;
  model?: string;
  sessionRecordingEnabled?: boolean;
  greetOnConnectEnabled?: boolean;
  address?: {
    id: string;
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postalCode: string;
    country?: string;
  };
  users?: Array<{
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  }>;
  number?: {
    id: string;
    e164Number: string;
    friendlyName: string;
    country: string;
    region?: string;
    locality?: string;
    source: "twilio" | "telnyx";
    boughtAt: string;
    externalId: string;
  };
  _count?: {
    users: number;
    orders: number;
    products: number;
    sessions: number;
  };
}

export interface CreateCompanyData {
  name: string;
  address?: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postalCode: string;
    country?: string;
  };
}

export interface UpdateCompanyData {
  name?: string;
  email?: string;
  phone?: string;
  systemPrompt?: string;
  promptFoundation?: string;
  assignedTools?: string[];
  numberId?: string;
  voice?: string;
  model?: string;
  sessionRecordingEnabled?: boolean;
  greetOnConnectEnabled?: boolean;
  address?: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postalCode: string;
    country?: string;
  };
}

class CompanyApiService {
  async getAllCompanies(): Promise<Company[]> {
    return apiClient.get<Company[]>(`/v1/companies`);
  }

  async getCompany(id: string): Promise<Company> {
    return apiClient.get<Company>(`/v1/companies/${id}`);
  }

  async createCompany(companyData: CreateCompanyData): Promise<Company> {
    return apiClient.post<Company>(`/v1/companies`, { data: companyData });
  }

  async updateCompany(
    id: string,
    companyData: UpdateCompanyData
  ): Promise<Company> {
    return apiClient.put<Company>(`/v1/companies/${id}`, { data: companyData });
  }

  async deleteCompany(id: string): Promise<void> {
    return apiClient.delete<void>(`/v1/companies/${id}`);
  }
}

export const companyApi = new CompanyApiService();
